import React from 'react';

const WidgetIndicateur = ({width = 20, height = 20, couleur = "#A8B0B3"}) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 40 40" fill="none">
        <path
            d="M18.2689 8.33203C10.9465 8.36681 5 14.3134 5 21.6654C5 29.0174 10.9813 34.9987 18.3333 34.9987C25.6634 34.9987 31.6319 29.0522 31.6667 21.7298"
            stroke={couleur} strokeWidth="4"/>
        <path d="M22 18.3314V4.99805C29.3367 5.03318 35.2982 10.9947 35.3333 18.3314H22Z"
              stroke={couleur} strokeWidth="4"/>
    </svg>
);

export default WidgetIndicateur;
